import { alpha } from '@mui/material'
import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
import { getResponsiveSize } from 'theme/styles.utils'

export const LoaderFullScreen = () => {
  return (
    <Box
      sx={(theme) => ({
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100vh',
        zIndex: 9999,
        background: alpha(theme.palette.background.default, 0.4),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      })}
    >
      <Box
        sx={(theme) => ({
          fontSize: `${getResponsiveSize(10)}rem`,
        })}
      >
        <CircularProgress />
      </Box>
    </Box>
  )
}
